import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {
  Avatar,
  Flex,
  Form,
  Layout,
  Space,
  Switch,
  TableColumnsType,
  TableProps,
  Typography,
  message,
} from "antd";
import {
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { EyeOutlined, InfoCircleOutlined } from "@ant-design/icons";

import { FormInstance } from "antd/lib";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import { routesConfig } from "../../../config/routes";
import {
  getListCourseAttendance,
  updateStatusSettingAttendance,
} from "../../../service/setting-attendance";
import { useStudyManagementStore } from "../../../stores/stores";
import { formatDate } from "../../../utils/converDate";
import FormFilter from "./components/filter-group/FormFilter";
import FilterTable from "./components/filter-table/FilterTable";
import { CheckRole, getPermissions } from "../../../utils/checkRole";
import { Permission } from "../../../layout/sidebar/permission.enum";
import CommonModal from "../../../components/modal/common";
import ConfirmModal from "../../../components/modal/confirm-modal/ConfirmModal";

type SettingRemindCheckInProps = {
  title?: string;
};

const SettingRemindCheckIn = ({ title }: SettingRemindCheckInProps) => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const { setTabAttendance } = useStudyManagementStore((state) => state);

  const [accountReportCheckIn, setAccountReportCheckIn] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isRefresh, setIsRefresh] = useState<boolean>(false);

  const [messageApi, contextHolder] = message.useMessage();

  const [displayRoleToggleAttendance, setDisplayRoleToggleAttendance] =
    useState(false);

  const [listPermission, setListPermission] = useState([]);
  const [isConfirm, setIsConfirm] = useState(false);
  const [statusAttendance, setStatusAttendance] = useState({
    id: NaN,
    status: false,
    is_active: false,
  });

  const getRoles = async () => {
    const params = await getPermissions();
    const listPermissionConvert = JSON.parse(JSON.stringify(params));
    setListPermission(listPermissionConvert);
  };

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    const roleToggleAttendance = [Permission.ToggleSwitchAttendanceModeUpdate];
    const checkRoleToggleAttendance = CheckRole(
      roleToggleAttendance,
      listPermission
    );
    if (checkRoleToggleAttendance.includes(true)) {
      setDisplayRoleToggleAttendance(true);
    }
  }, [listPermission]);

  const fetchData = async (searchParam: any) => {
    try {
      const response = await getListCourseAttendance(searchParam);
      const { data } = response.data;
      setAccountReportCheckIn(data.data);
      setTotalPage(data?.total?._count?.id);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData({
      course_name: searchValue,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
    });
  }, [pageSize, pageNumber, isRefresh]);

  const handleNotice = (message: string) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const dataColumnsReportCheckIn: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Mã khoá học", "Mã khoá học"),
      dataIndex: "code",
      key: "code",
      width: 20,
    },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "name",
      key: "name",
      width: 20,
      render: (_: any, record) => {
        return (
          <Flex className="table-order-course-name">
            <img
              className=""
              loading="eager"
              alt=""
              src={record?.image || "/images/ic_school_placeholder.svg"}
            />
            <div className="pl-2">
              <span className="course-title">{record?.name}</span>
              {/* <span>{record?.diaChi}</span> */}
            </div>
          </Flex>
        );
      },
      sorter: {
        compare: (a, b) => a.name.length - b.name.length,
      },
    },
    {
      title: t("Bật/Tắt điểm danh", "Bật/Tắt điểm danh"),
      dataIndex: "trangThai",
      key: "trangThai",
      render: (_: any, record: any) => {
        const handleChange = (checked: boolean) => {
          if (!checked) {
            setIsConfirm(true);
          }
          else{
            handleChangeStatusAttendance(record.id, checked, record?.mooc_setting_attendance[0]?.is_active);
          }
          setStatusAttendance({
            id: record.id,
            status: checked,
            is_active: record?.mooc_setting_attendance[0]?.is_active
          });
        };

        return (
          <div>
            <Switch
              disabled={!displayRoleToggleAttendance}
              checked={record?.mooc_setting_attendance[0]?.status_attendance}
              onChange={handleChange}
            />
          </div>
        );
      },
      width: 15,
    },
    {
      title: t("Bật/Tắt chế độ điểm danh tự động", "Bật/Tắt chế độ điểm danh tự động"),
      dataIndex: "trangThai",
      key: "trangThai",
      render: (_: any, record: any) => {
        const handleChange = (checked: boolean) => {
          record.trangThai = checked;
          handleChangeStatus(record?.id, record.trangThai);
        };

        return (
          <div>
            {record?.mooc_setting_attendance[0]?.status_attendance && (
              <Switch
                disabled={!displayRoleToggleAttendance}
                checked={record?.mooc_setting_attendance[0]?.is_active}
                onChange={handleChange}
              />
            )}
          </div>
        );
      },
      width: 15,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };
        const onLink = () => {
          setTabAttendance("1");
          navigate(
            `/management-study/${routesConfig.settingRemindCheckInDetail}/${location?.id}`
          );
        };
        return (
          <Space>
            {record?.mooc_setting_attendance[0]?.status_attendance && (
              <span className="action-table cursor-pointer" onClick={onLink}>
                <EyeOutlined />
              </span>
            )}
          </Space>
        );
      },
      fixed: "right",
      width: 8,
    },
  ];

  const defaultCheckedList = dataColumnsReportCheckIn.map(
    (item) => item.key as string
  );

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const columnChecked = useMemo(() => {
    return dataColumnsReportCheckIn.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList, displayRoleToggleAttendance, isRefresh]);

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = async (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      const searchParam = {
        take: 10,
        skip: 0,
        course_name: searchValue,
      };
      setPageNumber(1);
      fetchData(searchParam);
    }
  };

  const handleSubmitSearch = () => {
    const searchParam = {
      take: 10,
      skip: 0,
      course_name: searchValue,
    };
    setPageNumber(1);
    fetchData(searchParam);
  };

  const clearFilter = async (formInstance: FormInstance) => {
    setLoading(true);

    setSearchValue("");
    const searchParam = {
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
      course_name: searchValue,
    };
    fetchData(searchParam);
    formInstance.resetFields();
  };

  const handleChangeStatus = async (
    id: number | string,
    is_active: boolean
  ) => {
    try {
      await updateStatusSettingAttendance(id, { is_active });
      handleNotice(
        !is_active ? t("Đã tắt cài đặt điểm danh", "Đã tắt cài đặt điểm danh") : t("Đã bật cài đặt điểm danh", "Đã bật cài đặt điểm danh")
      );
      setIsRefresh(!isRefresh);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: t("Lỗi khi thay đổi trạng thái!", "Lỗi khi thay đổi trạng thái!"),
      });
    }
  };

  const handleChangeStatusAttendance = async (
    id: number | string,
    status_attendance: boolean,
    is_active: boolean
  ) => {
    try {
      await updateStatusSettingAttendance(id, { status_attendance, is_active });
      handleNotice(
        !status_attendance ? t("Đã tắt điểm danh", "Đã tắt điểm danh") : t("Đã bật điểm danh", "Đã bật điểm danh")
      );
      setIsRefresh(!isRefresh);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: t("Lỗi khi thay đổi trạng thái!", "Lỗi khi thay đổi trạng thái!"),
      });
    }
  };

  const handleFinish = (values: any) => {
    setLoading(true);

    const searchParam = {
      ...values,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
      course_name: searchValue,
    };
    fetchData(searchParam);
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {};

  const handleConfirm = () => {
    handleChangeStatusAttendance(statusAttendance?.id, statusAttendance?.status, statusAttendance?.is_active);
    setIsConfirm(false);
  };
  return (
    <Layout className="page-header-group">
      {contextHolder}
      <Form.Provider>
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper justify-between">
            <div className="table-header--left">
              <PageHeader title={title} />
            </div>
            <FilterTable
              searchValue={searchValue}
              dataColumns={dataColumnsReportCheckIn}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            onFinish={handleFinish}
            showFilter={showFilter}
          />
        </div>
        <TableData
          dataTable={accountReportCheckIn}
          dataColumns={columnChecked}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1200, y: 600 }}
          totalRecords={totalPage}
          handleTableChangeProps={handleTableChange}
        />
        <CommonModal
          open={isConfirm}
          title={t("Bạn đang thực hiện tắt chế độ điểm danh cho khóa học này", "Bạn đang thực hiện tắt chế độ điểm danh cho khóa học này")}
          desc={
            <div>
              <p>{t("Khi tắt chế độ điểm danh:", "Khi tắt chế độ điểm danh:")}</p>
              <p className="">
                {t("- Hệ thống sẽ dừng ghi nhận hoạt động điểm danh của sinh viên", "- Hệ thống sẽ dừng ghi nhận hoạt động điểm danh của sinh viên")}
              </p>
              <p>{t("- Dữ liệu điểm danh hiện tại sẽ được lưu trữ để tham khảo", "- Dữ liệu điểm danh hiện tại sẽ được lưu trữ để tham khảo")}</p>
              <div className="text-center pt-3 font-semibold text-[#333] text-[10px]">
                {t("Bạn có thể kích hoạt lại chế độ điểm danh bất kỳ lúc nào trong phần Cài đặt điểm danh của khóa học", "Bạn có thể kích hoạt lại chế độ điểm danh bất kỳ lúc nào trong phần Cài đặt điểm danh của khóa học")}
              </div>
            </div>
          }
          closeIcon={true}
          okText={t("Xác nhận", "Xác nhận")}
          cancelText={t("Huỷ", "Huỷ")}
          icon={
            <InfoCircleOutlined
              style={{ color: "#FFC53D", marginRight: "10px" }}
            />
          }
          confirm={handleConfirm}
          closeModal={() => setIsConfirm(false)}
        />
      </Form.Provider>
    </Layout>
  );
};

export default SettingRemindCheckIn;
